import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import Navigation from '../components/Navigation';
import Footer from '../sections/Footer';
import Button from '../components/Button';
import ExternalLink from '../components/ExternalLink';

import CheckIconPath from '../images/icons/check.svg';
import InfiniteIconPath from '../images/icons/infinite.svg';
import faviconPath from '../images/favicon.ico';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 0 0;
  font-family: Roboto;
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Heading = styled.div`
  font-weight: bold;
  font-size: 50px;
  line-height: 59px;
  color: rgba(0, 0, 0, 0.870588);
  margin-top: 127px;
  user-select: none;
`;

const Card = styled.div`
  width: 300px;
  background: #FFFFFF;
  border: 0.25px solid rgba(0, 0, 0, 0.75);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin-top: 77px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 155px;
`;

const CardAccentBar = styled.div`
  height: 5px;
  background: linear-gradient(175.18deg, #0051F0 0%, #00C9F0 99.99%, #0051F0 100%);
  border-radius: 4px 4px 0px 0px;
  width: 100%;
`;

const PlanHeading = styled.div`
  font-size: 20px;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
  margin-top: 15px;
`;

const Price = styled.div`
  font-weight: bold;
  font-size: 50px;
  line-height: 59px;
  color: rgba(0, 81, 175, 0.870588);
`;

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 40px;
`;

const Currency = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.45);
`;

const PlanPeriod = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 19px;
`;

const PlanDescription = styled.div`
  margin-top: 17px;
  font-size: 14px;
  line-height: 130%;
  color: rgba(0, 0, 0, 0.6);
  max-width: 192px;
`;

const FeaturesWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;

const Feature = styled.div`
  margin-top: 9px;
  display: flex;
  flex-direction: row;
`;

const CheckIcon = styled.img`
  margin-right: 8.5px;
`;

const FeatureText = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.870588);
`;

const SignupButton = styled(Button)`
  margin: 26px 0 26px 0;
  background: linear-gradient(
    137.8deg,
    #0051f0 0%,
    #00c9f0 99.99%,
    #0051f0 100%
  );
  text-align: center;
  width: 165px;
  border-radius: 4px;
  width: 160px;
`;

const Pricing = () => (
  <Container>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Pricing - Bidmatik</title>
      <link rel="canonical" href="https://bidmatik.com/pricing" />
      <link rel="shortcut icon" type="image/png" href={faviconPath} />
    </Helmet>
    <Navigation />
    <Center>
      <Heading>
        Simple Pricing
      </Heading>
      <Card>
        <CardAccentBar />
        <PlanHeading>
          Professional
        </PlanHeading>
        <PriceWrapper>
          <Price>
            239
          </Price>
          <Currency>
            $
          </Currency>
        </PriceWrapper>
        <PlanPeriod>
          per month
        </PlanPeriod>
        <PlanDescription>
          For professionals to automate sponsored product
           campaigns and increase ad performance on Amazon.
        </PlanDescription>
        <FeaturesWrapper>
          <Feature>
            <CheckIcon src={CheckIconPath} />
            <FeatureText>
              Bid optimisation
            </FeatureText>
          </Feature>
          <Feature>
            <CheckIcon src={CheckIconPath} />
            <FeatureText>
              Keyword Discovery
            </FeatureText>
          </Feature>
          <Feature>
            <CheckIcon src={CheckIconPath} />
            <FeatureText>
              Updated Negatives
            </FeatureText>
          </Feature>
          <Feature>
            <CheckIcon src={CheckIconPath} />
            <FeatureText>
              Unlimited History
            </FeatureText>
          </Feature>
          <Feature>
            <CheckIcon src={CheckIconPath} />
            <FeatureText>
              Scheduled Reports
            </FeatureText>
          </Feature>
          <Feature>
            <CheckIcon src={CheckIconPath} />
            <FeatureText>
              Product Level Insight
            </FeatureText>
          </Feature>
          <Feature>
            <CheckIcon src={InfiniteIconPath} />
            <FeatureText>
              Unl. Seller Central Profiles
            </FeatureText>
          </Feature>
        </FeaturesWrapper>
        <ExternalLink href="https://calendly.com/lars_bidmatik/bidmatik-product-demo?month=2019-07">
          <SignupButton>
            Schedule your Demo
          </SignupButton>
        </ExternalLink>
      </Card>
    </Center>
    <Footer showBackground />
  </Container>
);

export default Pricing;
